<template>
  <div class="margin-t-30 status-list scroll-styling rounded-lg ">
    <div class="library-block flex-center top inl-100">
      <div class="lib-filter clint-form inl-20">
        <h2 class="font-semibold text-3xl mb-5">Библиотека</h2>
        <div class="form-group mb-3">
          <label for="">Поиск</label>
          <input
            v-on:keyup.enter="inputSearch"
            type="text"
            placeholder="Введите название"
          />
        </div>
        <div class="form-group">
          <label for="">Категория</label>
          <model-select
            :options="getSelectOptionsBase(categories, 'uuid', 'name')"
            v-model="category"
            placeholder="Выберите категорию"
          >
          </model-select>
        </div>
      </div>

      <div class=" left">

      <div class="nav-block flex-center right px-6 py-3">
        <div class="mr-5 f-14 mobile-hidden">Страница:</div>
        <div class="mr-5 f-14 hidden"></div>
        <div class="mr-5">
          <select
            id="countries_disabled"
            @change="selectPage"
            style="width: 60px"
            class="bg-gray-50 border bg-white border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          >
            <option
              v-for="(item, index) in navItems"
              :key="index + 1"
              :value="index + 1"
              :selected="currentPage == index + 1"
            >
              {{ index + 1 }}
            </option>
          </select>
        </div>
        <div class="count-data f-14 ml-4 mobile-hidden">
          <span v-if="currentPage == 1">1</span>
          <span v-else>{{ (currentPage - 1) * post_per_page }}</span>
          –
          <span v-if="currentPage * post_per_page > allCount">{{
            allCount
          }}</span>
          <span v-else>{{ currentPage * post_per_page }}</span>
          из {{ allCount }}
        </div>
        <div class="ml-7 btn-n-p f-14 flex-center fl-start mobile-hidden">
          <div @click="prevPage" class="pointer">
            <svg
              class=""
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 8 14"
            >
              <path
                :class="[currentPage == 1 ? 'text-gray-200' : 'text-gray-600']"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 1 1.3 6.326a.91.91 0 0 0 0 1.348L7 13"
              />
            </svg>
          </div>

          <div @click="nextPage" class="pointer ml-5">
            <svg
              class=""
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 8 14"
            >
              <path
                :class="[
                  currentPage >= lastPage ? 'text-gray-200' : 'text-gray-600',
                ]"
                class=""
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"
              />
            </svg>
          </div>
        </div>
      </div>


        <div class="inl-100 text-left left">
          <div class="library-list shadow-md scroll-styling">
            <a
              target="_blank"
              v-for="(el, ind) in libraries"
              :key="ind"
              :href="el.file"
              class="item inl-block margin-bt-10"
            >
              <div class="top-text flex-center fl-start">
                <div class="f-14 margin-r-10">
                  <span>Категория:</span> {{ el.cat.name }}
                </div>
                <div class="f-14 margin-r-10">|</div>
                <div class="f-14 margin-r-10">
                  <span>Дата создания:</span>
                  {{ formatDate(el.created_at) }}
                </div>
                <div class="f-14 margin-r-10">|</div>
                <div class="f-14 margin-r-10">
                  <span>Автор:</span> {{ el.author }}
                </div>
              </div>
              <div class="title font-bold f-18 margin-t-10">
                {{ el.name }}
              </div>
              <div class="title f-18 margin-t-10">
                {{ el.description }}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import { getSelectOptionsBase } from "@/utils/base";
import { API_CLIENT, HEADERS_JSON, DEFAULT_PER_PAGE } from "@/const/uri";
import axios from "axios";

export default {
  components: {
    ModelSelect,
  },
  data() {
    return {
      navItems: [],
      max_page: 0,
      currentPage: 1,
      categories: [],
      libraries: [],
      isCategoryLoaded: false,
      category: null,
      post_per_page: DEFAULT_PER_PAGE,
      searchVal: null,
      allCount: 0,
      lastPage: 0,
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    $route(to, from) {
      if (to.name != from.name) {
        this.currentPage = 1;
      }
      this.currentPage = parseInt(to.query.page) || 1;
      this.searchVal = "";
      this.loadData();
    },
    category(to, from,) {
      if(to != from) {
        this.loadData();
      }
    },
  },
  methods: {
    getSelectOptionsBase,
    updateNavItems(count) {
      const countData = count;
      const pages = Math.ceil(countData / this.post_per_page);
      this.navItems = [];
      for (let index = 0; index < pages; index++) {
        this.navItems.push(index + 1);
      }
      if (pages == 0) {
        this.navItems.push(1);
      }
    },
    formatDate(date) {
      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
      };
      const formatter = new Intl.DateTimeFormat("ru-RU", options);
      return formatter.format(date);
    },
    inputSearch(e) {
      this.searchVal = e.target.value;
      this.loadData();
    },
    getCurrentPage() {
      const page = parseInt(this.$route.query.page) || 1;
      if (isNaN(page)) {
        this.currentPage = 1;
        return 1;
      }
      this.currentPage = page;
      return page;
    },
    selectPage(e) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: e.target.value,
        },
      });
    },
    prevPage() {
      if (this.currentPage == 1) return;
      this.currentPage -= 1;
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.currentPage,
        },
      });
    },
    nextPage() {
      if (this.lastPage > this.currentPage) {
        this.currentPage += 1;
        this.$router.replace({
          path: this.$route.path,
          query: {
            page: this.currentPage,
          },
        });
      }
    },
    async loadData() {
      await axios({
        method: "GET",
        params: {
          is_load: this.isCategoryLoaded ? 1 : 0,
          cat: this.category,
          p: this.currentPage,
          q: this.searchVal,
        },
        headers: HEADERS_JSON,
        url: API_CLIENT.library,
      })
        .then((e) => {
          const categories = e.data.data.categories;
          this.libraries = [];
          this.allCount = e.data.data.count;
          this.updateNavItems(e.data.data.count);
          this.lastPage = Math.ceil(this.allCount / this.post_per_page);
          e.data.data.results.forEach((obj) => {
            this.libraries.push({
              ...obj,
              created_at: new Date(obj.created_at),
            });
          });
          if (categories) {
            this.categories = categories;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  props: {},
};
</script>